import { useState, useEffect } from 'react';
import styled, { css } from 'styled-components';
// import { OutlinedCTAButton } from '~/components/OutlinedCTALink';
// import theme from '~/styles/styledComponentsTheme';
import ContentShareWidget from '~/components/ContentShareWidget';
import { ACTION_BAR_OWNER_TYPE_VIBE } from '~/globals';
import { useTagService } from '~/api/hooks/useTagService';
import { useAuthService } from '~/api/hooks/useAuthService';
// import { useModals } from '~/hooks/useModals';
import { EventParams } from '~/globals/trackEvent';
import { isClient } from '~/utils/ssr';
import Typography from '~/atoms/Typography';

const Container = styled('div')`
  padding: 32px 16px;
  max-width: 100%;
`;

const Details = styled('div')`
  margin: 0 0 24px 0;
`;

const ShareIconContainer = styled('div')`
  height: 24px;
  width: 24px;
  margin: 0 0 16px auto;
  transform: scale(1.5);
`;

const DescriptionContent = styled('p')<{ $open?: boolean }>`
  display: block;
  font-size: 1.125em;
  max-height: ${(props) => (props.$open ? '500px' : '80px')};
  overflow-y: hidden;
  transition: max-height 0.7s linear;
`;

const DescriptionExpandButton = styled('button')`
  margin-top: 8px;
  font-weight: Calibre;
  font-size: 1.125em;
  font-weight: bold;
  background: none;
  text-decoration: underline;
  cursor: pointer;
`;

// const Footer = styled('div')`
//   display: flex;
//   margin: 32px 0 0 0;
// `;

// const SubscribeButton = styled(OutlinedCTAButton)<{ $isSubscribed?: boolean }>`
//   max-width: 130px;
//   width: 100%;
//   height: 40px;
//   padding: 0;
//   border-radius: 20px;
//   background: ${(props) => (props.$isSubscribed ? theme.highlight_7_0 : theme.white)};
//   color: ${(props) => (props.$isSubscribed ? theme.white : theme.black)};
//   transition: background-color 0.3s ease;

//   ${(props) =>
//     props.$isSubscribed
//       ? css`
//           border: none;
//         `
//       : ''}
// `;

type Props = {
  title: string;
  description: string;
  slug: string;
  isLocation?: boolean;
};

const VibeInfo = ({ title, description, slug, isLocation }: Props) => {
  const [expandDescription, setExpandDescription] = useState(false);
  const {
    // subscribeTag,
    // subscribeLocation,
    // unsubscribeLocation,
    // unsubscribeTag,
    isSubscribedToTag,
    isSubscribedToLocation,
  } = useTagService();
  const [isSubscribed, setIsSubscribed] = useState(false);
  const { loggedIn } = useAuthService();
  // const { openLoginModal } = useModals();

  useEffect(() => {
    if (loggedIn) {
      verifySubscription();
    }
  }, []);

  const verifySubscription = async () => {
    if (isLocation) {
      const { subscribed } = await isSubscribedToLocation(slug);
      setIsSubscribed(subscribed);
    } else {
      const { subscribed } = await isSubscribedToTag(slug);
      setIsSubscribed(subscribed);
    }
  };

  const toggleDescription = () => {
    setExpandDescription(!expandDescription);
  };

  // const handleSubscribe = async () => {
  //   if (!loggedIn) {
  //     openLoginModal();
  //     return;
  //   }

  //   if (isLocation) {
  //     handleSubscribeToLocation();
  //     return;
  //   }

  //   handleSubscribeToTag();
  // };

  // const handleSubscribeToTag = async () => {
  //   if (isSubscribed) {
  //     await unsubscribeTag(slug);
  //     setIsSubscribed(false);
  //     return;
  //   }

  //   await subscribeTag(slug);
  //   setIsSubscribed(true);
  // };

  // const handleSubscribeToLocation = async () => {
  //   if (isSubscribed) {
  //     await unsubscribeLocation(slug);
  //     setIsSubscribed(false);
  //     return;
  //   }

  //   await subscribeLocation(slug);
  //   setIsSubscribed(true);
  // };

  return (
    <EventParams section={isLocation ? 'location_info_card' : 'style_info_card'}>
      <Container>
        <ShareIconContainer>
          <ContentShareWidget
            ownerType={ACTION_BAR_OWNER_TYPE_VIBE}
            ownerId={slug}
            shareOptions={{
              title,
              url: isClient() && window.location.href,
            }}
          />
        </ShareIconContainer>
        <Details>
          <Typography variant="h1" padding="0" margin="0 0 16px 0" fontWeight="800">
            {title}
          </Typography>
          <div>
            <DescriptionContent $open={expandDescription}>{description}</DescriptionContent>
            {description?.length > 160 && (
              <DescriptionExpandButton onClick={toggleDescription}>Read More</DescriptionExpandButton>
            )}
          </div>
        </Details>
        {/* Hiding for now since subscribing doesn't do anything for the user.
         <Footer>
          <SubscribeButton
            eventAction={isSubscribed ? 'Unsubscribe' : 'Subscribe'}
            $isSubscribed={isSubscribed}
            onClick={handleSubscribe}
          >
            {isSubscribed ? 'Subscribed' : 'Subscribe'}
          </SubscribeButton>
        </Footer> */}
      </Container>
    </EventParams>
  );
};

export default VibeInfo;
